import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { message } from "antd";
import Event from "./event";
import "./events.css";

const Events = () => {
  const [items, setItems] = useState([]);

  const getData = () => {
    serverFetch("event")
      .then(data => setItems(data))
      .catch(e => message.error(e.userMessage));
  }


  useEffect(() => {
    const interval = setInterval(getData, 3000);
    return () => clearInterval(interval); // Очистка при размонтировании
  }, []); // Пустой массив зависимостей = запуск только при монтировании



  return<div className="events">
    {/* <div>EVETNS</div> */}
    {items.map(i => <Event key={i.id} item={i} onRefresh={getData}/>)}
  </div>

}

export default Events;